import { FC, useRef, useState } from "react";
import orderOptimizerTranslationsHelper from "../../../../../languages/order-optimizer-translations.helper";
import ButtonComponent from "../../../../../common/components/button/button.component";
import useKeyboardPress from "../../../../../common/hooks/use-keyboard-press";
import OrderOptimizerCargoListingFilter from "../common/types/order-optimizer-cargo-listing-filter";
import OrderOptimizerCargoListingFilterType from "../common/types/order-optimizer-cargo-listing-filter-type";
import ListingFilterComponent from "../../../../../common/components/listing/filter/listing-filter.component";
import ListingFilterDefinition from "../../../../../common/components/listing/filter/types/listing-filter-definition";
import orderOptimizerCargoListingFiltersHelper from "./order-optimizer-cargo-listing-filters.helper";

type OrderOptimizerCargoListingFiltersProps = {
  filters: OrderOptimizerCargoListingFilter[];
  isListingLoading: boolean;
  onFiltersChange: (filters: OrderOptimizerCargoListingFilter[]) => void;
};

const OrderOptimizerCargoListingFiltersComponent: FC<
  OrderOptimizerCargoListingFiltersProps
> = (props) => {
  const translations =
    orderOptimizerTranslationsHelper.getCargoListingTranslations().filters;

  const [filterSearchQuery, setFilterSearchQuery] = useState<number | null>(
    () =>
      props.filters.find(
        (filter) =>
          filter.type == OrderOptimizerCargoListingFilterType.ORDER_HUMAN_ID,
      )?.value ?? null,
  );

  const inputRef = useRef<HTMLInputElement>(null);

  useKeyboardPress({
    Enter: () => addFilter(),
    ref: inputRef,
  });

  const addFilter = () => {
    const newAppliedFilters: OrderOptimizerCargoListingFilter[] = [];

    if (filterSearchQuery) {
      const newFilter: OrderOptimizerCargoListingFilter = {
        type: OrderOptimizerCargoListingFilterType.ORDER_HUMAN_ID,
        value: filterSearchQuery,
      };

      newAppliedFilters.push(newFilter);
    }

    props.onFiltersChange(newAppliedFilters);
  };

  const filterDefinition: ListingFilterDefinition<OrderOptimizerCargoListingFilter> =
    orderOptimizerCargoListingFiltersHelper().getFilterDefinition();

  return (
    <div className="order_optimizer_cargo_listing_filter">
      <div className="order_optimizer_cargo_listing_filter__input_wrapper">
        <ListingFilterComponent
          appliedFilters={props.filters}
          filterDefinition={filterDefinition}
          onFiltersChange={(appliedFilters) => {
            props.onFiltersChange(
              appliedFilters as OrderOptimizerCargoListingFilter[],
            );
          }}
          sortDefinition={{ options: [] }}
          appliedSortKey=""
          onSortKeyChange={() => {}}
        />
      </div>
      <ButtonComponent
        onClick={() => {
          setFilterSearchQuery(null);
          props.onFiltersChange([]);
        }}
        classNames={{
          root: "order_optimizer_cargo_listing_filter__button",
        }}
        isLoading={props.isListingLoading}
        title={translations.getAllOrdersButtonLabel}
        type="primary"
        idForTesting="order-optimizer-listing-filter-button"
      >
        {translations.getAllOrdersButtonLabel}
      </ButtonComponent>
    </div>
  );
};

export default OrderOptimizerCargoListingFiltersComponent;
